import { BaseBody } from '../BaseBody.js';
import { CssVars } from '../../../util/CssVars.js';

const glyphname = 'modeZo';
const args = {};

export class ModeZo extends BaseBody {
  constructor() {
    super(glyphname, args);
  }
}
